import React from "react";
import { size } from "./PayloadView";

/** "128 rows", "12.4k rows" */
const fmtRows = (n) => (n >= 10000 ? `${(n / 1000).toFixed(n >= 100000 ? 0 : 1)}k` : n.toLocaleString("en-US")) + (n === 1 ? " row" : " rows");

const CELL = { saved: "ok", empty: "none", pending: "amber", missing: "red", not_yet: "none" };
const LABEL = { empty: "0 rows", pending: "Pending", missing: "Missing", not_yet: "Not yet" };

/** Saved data view: one cell per store and report, from the payload table alone. */
export default function SavedMatrix({ columns, stores, onOpen, retrying }) {
  const groups = [];
  columns.forEach((c) => {
    const last = groups[groups.length - 1];
    if (last && last.product === c.product) last.span += 1; else groups.push({ product: c.product, span: 1 });
  });
  const NAMES = { SP: "Sponsored Products", SB: "Sponsored Brands", SD: "Sponsored Display", STV: "Sponsored TV" };
  return (
    <div className="ams-tablewrap rh-wrap">
      <table className="ams-table rh-table">
        <thead>
          <tr>
            <th rowSpan={2} className="rh-store-h">Store</th>
            <th rowSpan={2} className="ams-num">With data</th>
            {groups.map((g, i) => (
              <th key={i} colSpan={g.span} className={`rh-group rh-group--${(g.product || "other").toLowerCase()}`}>{NAMES[g.product] || "Other"}</th>
            ))}
          </tr>
          <tr>{columns.map((c) => <th key={c.name} className="rh-col" title={c.name}>{c.short}</th>)}</tr>
        </thead>
        <tbody>
          {stores.length ? stores.map((s) => {
            const lvl = s.severity === 2 ? "red" : s.severity === 1 ? "amber" : "ok";
            return (
              <tr key={s.profileId} className={`ams-edge--${lvl}`}>
                <td className="ams-name rh-store">
                  {s.storeName || <span className="ams-dash">Unknown store</span>}
                  <dl className="ams-idlist">
                    {s.market && <><dt>Market</dt><dd>{s.market}</dd></>}
                    <dt>Profile</dt><dd>{s.profileId}</dd>
                  </dl>
                  {s.issue && <div className="rh-store-issue">{s.issue}</div>}
                </td>
                <td className={`ams-num rh-saved${s.issue ? " ams-bad" : s.counts.saved < s.expected ? " ams-warn" : ""}`}>
                  {s.counts.saved}<span className="ams-dash"> / {s.expected}</span>
                  {s.bytes > 0 && <div className="sd-sub">{size(s.bytes)}</div>}
                </td>
                {columns.map((c) => {
                  const cell = s.cells[c.name];
                  if (!cell || cell.state === "none") return <td key={c.name} className="rh-cell"><span className="rh-blank">–</span></td>;
                  const tip = `${c.name}: ${cell.text}${cell.bytes ? ` (${size(cell.bytes)} saved)` : ""}`;
                  if (retrying && retrying.has(`${s.profileId}|${c.name}`)) {
                    return (
                      <td key={c.name} className="rh-cell">
                        <button type="button" className="rh-pill rh-pill--requested" onClick={() => onOpen(s, c)}>
                          <span className="ams-spin rh-spin" aria-hidden="true" />Retrying
                        </button>
                      </td>
                    );
                  }
                  return (
                    <td key={c.name} className="rh-cell">
                      <button type="button" className={`rh-pill rh-pill--${CELL[cell.state]}`} title={tip} aria-label={tip}
                              onClick={() => onOpen(s, c)}>
                        {cell.state === "saved"
                          ? (cell.dataRows != null ? <>✓ {fmtRows(cell.dataRows)}</> : <>✓ {size(cell.bytes)}</>)
                          : LABEL[cell.state]}
                      </button>
                      {cell.state === "missing" && cell.reason && <div className={`sd-sub rh-reason`}>{cell.reason}</div>}
                    </td>
                  );
                })}
              </tr>
            );
          }) : <tr><td colSpan={columns.length + 2} className="ams-empty">No stores match this filter.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
